import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-load-balancers-professional',
  templateUrl: './load-balancers-professional.component.html',
  styleUrls: ['./load-balancers-professional.component.scss']
})
export class LoadBalancersProfessionalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}